export const fetchDurationDiscounts = async ({rentals, setDurationDiscounts}) => {
  try {
    const response = await rentals.getDurationDiscounts();
    setDurationDiscounts(response.data);
  } catch (error) {
    console.error("Error fetching duration discounts:", error);
  }
};
